<template>
  <i :class="classes" :style="style"></i>
</template>

<script>
  export default {
    props: {
      x: {
        type: [String, Number],
        default: 0
      },

      y: {
        type: [String, Number],
        default: 0
      },

      type: {
        type: String,
        default: ''
      }
    },

    computed: {
      classes: function() {
        return ['connector', `connector--${this.type}`];
      },

      style: function() {
        return {
          transform: `translate(${this.x}px, ${this.y}px)`
        };
      }
    }
  };
</script>

<style lang="scss">
  .connector {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #ff0000;
    z-index: 4;

    @each $type, $color in $pbx-action-types {
      &--#{$type} {
        background-color: $color;
      }
    }
  }
</style>
